import type { FC } from "react";
import { useNavigate } from "react-router";

import type { AcquirerEntity } from "src/app/features/Acquirer/types/AcquirerEntity";
import type { ManualDasConfigurationEntity } from "src/app/features/ManualDasConfiguration/types/ManualDasConfigurationEntity";
import { DangerButton, SecondaryButton } from "../../../../../components/Buttons/components/ActionButton";
import type { ButtonProps } from "../../../../../components/FeatureButtons/types";
import { ResourceName, ResourceVariant } from "../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../core/router/types/routerTypes";

interface DasConfigAcquirerButtonProps extends ButtonProps<ManualDasConfigurationEntity> {
    acquirers?: AcquirerEntity[];
    type?: string;
}

export const AcquirerButton: FC<DasConfigAcquirerButtonProps> = ({ acquirers, type }) => {
    const navigate = useNavigate();
    const onClick = (acquirer: AcquirerEntity) => {
        navigate(`${BASE_PATH}/${ResourceName.ACQUIRER}/${ResourceVariant.PHYSICAL}/${FORM_ACTION.EDIT}/${acquirer.id}`);
    };

    return (
        acquirers?.map((acquirer) =>
            type === "danger" ? (
                <DangerButton style={{ margin: "3px" }} key={acquirer.id} name={acquirer.name} onClick={() => onClick(acquirer)}>
                    {`${acquirer.name} (${acquirer.id})`}
                </DangerButton>
            ) : (
                <SecondaryButton style={{ margin: "3px" }} key={acquirer.id} name={acquirer.name} onClick={() => onClick(acquirer)}>
                    {`${acquirer.name} (${acquirer.id})`}
                </SecondaryButton>
            ),
        ) ?? null
    );
};
